import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import TagAdd from './TagAdd'
import { XCircleIcon } from 'images/common'
import './style.scss'

const Tag = ({ tags: initialTags, placeholder, name, hideLabel, onChange, color = 'label', autocomplete = [], suggestions = [], hideAdd, dropUp, dropPosition, isDropDown, isSingleSelect }) => {
  const [tag, setTag] = useState('')
  const [tags, setTags] = useState(initialTags || [])

  const itemClass = classNames(
    'viso-tag__item hasHover',
    `viso-tag__item--${color}`
  )

  useEffect(() => { setTags(initialTags || []) }, [initialTags])

  const onRemove = (selectedTag) => {
    const updatedTags = tags.filter(tag => tag !== selectedTag)
    updateTags(updatedTags)
  }

  const updateTags = (tags) => {
    setTags(tags)
    onChange && onChange(tags)
  }

  const onSuggestionClick = (value) => {
    const updatedTags = [...tags, value]
    updateTags(updatedTags)
  }

  return (
    <div className='viso-tag'>
      {!hideLabel && <label className='viso-tag__label'>{name || 'Tags'}</label>}
      <div className={'viso-tag__container'}>
        {!!tags.length && tags?.map(item => (
          <button
            className={itemClass}
            key={isDropDown ? item.label : item}
            type='button'
            onClick={() => onRemove(item)}
          >
            {isDropDown ? item.label : item}
            <span className='viso-tag__remove'>
              <XCircleIcon />
            </span>
          </button>
        ))}
        {!(hideAdd || (isSingleSelect && tags.length === 1)) &&
          <TagAdd
            placeholder={placeholder}
            tag={tag}
            tags={tags}
            suggestions={suggestions}
            setTag={setTag}
            updateTags={updateTags}
            onRemove={onRemove}
            color={color}
            autocomplete={autocomplete}
            dropUp={dropUp}
            dropPosition={dropPosition}
            isDropDown={isDropDown}
          />
        }
        {suggestions.length > 0 && suggestions.filter(suggestion => !tags.includes(suggestion)).map(item =>
          <div
            key={item}
            className='viso-tag__item viso-tag__item--suggestion'
            onClick={() => onSuggestionClick(item)}
          >
            {item}
          </div>
        )}
      </div>
    </div>
  )
}

export default Tag